import makeSlice from '@web/slices/recommendationProduct/sliceMaker'

const recommendationProductSlice = makeSlice()

export default recommendationProductSlice.reducer
